const localStorageSecureWrapper = (() => {
  function generateFingerprint() {
    const { userAgent, hardwareConcurrency } = window.navigator;
    const fingerprint = `${userAgent}-${hardwareConcurrency}`;
    return fingerprint;
  }

  const fingerprint: string = generateFingerprint();

  function simpleHash(str: string): string {
    let h = 0;
    for (let i = 0; i < str.length; i++) {
      h = (h << 5) - h + str.charCodeAt(i);
      h |= 0;
    }
    return Math.abs(h).toString();
  }

  const secretKey = simpleHash(fingerprint);

  function xorEncrypt(str: string): string {
    let r = "";
    for (let i = 0; i < str.length; i++) {
      r += String.fromCharCode(
        str.charCodeAt(i) ^ secretKey.charCodeAt(i % secretKey.length),
      );
    }
    return btoa(r);
  }

  function xorDecrypt(str: string): string {
    const data = atob(str);
    let r = "";
    for (let i = 0; i < data.length; i++) {
      r += String.fromCharCode(
        data.charCodeAt(i) ^ secretKey.charCodeAt(i % secretKey.length),
      );
    }
    return r;
  }

  function getSecureKey(key: string): string {
    return "lsSecWrap_" + simpleHash(key);
  }

  return {
    setItem(key: string, value: unknown): void {
      const secureKey = getSecureKey(key);
      const toEncrypt =
        typeof value === "string" ? value : JSON.stringify(value);
      localStorage.setItem(secureKey, xorEncrypt(toEncrypt));
    },
    getItem(key: string): unknown {
      const secureKey = getSecureKey(key);
      const encrypted = localStorage.getItem(secureKey);
      if (!encrypted) return null;
      const decrypted = xorDecrypt(encrypted);
      try {
        return JSON.parse(decrypted);
      } catch {
        return decrypted;
      }
    },
    removeItem(key: string): void {
      localStorage.removeItem(getSecureKey(key));
    },
    clear(): void {
      localStorage.clear();
    },
    key(index: number): string | null {
      const k = localStorage.key(index);
      return k && k.startsWith("lsSecWrap_") ? k : null;
    },
  };
})();

export default localStorageSecureWrapper;
